import { routerReady } from '@/utils/ready';
import qs from 'qs';
import { isIncreasePriceForPH } from '@/common/hardcode';

const TIMESTAMP_KEY = '_';
const defaultNameSpace = `${Date.now()}`;
const query = qs.parse(location.search.slice(1));
const DEFAULT_EXPIRES = 1000 * 60 * 60 * 1;



function getNamespace(def) {
  if(query[TIMESTAMP_KEY]) {
    return query[TIMESTAMP_KEY];
  }
  return def;
}

function setNamespace(namespace) {
  const newSearchStr = qs.stringify({ ...query, [TIMESTAMP_KEY]: namespace });
  history.replaceState({}, '', `${location.pathname}?${newSearchStr}${location.hash}`);
}

class NStorage {
  storage = window.sessionStorage
  pkey = '__opc_state_cache__';
  namespace = getNamespace(defaultNameSpace);
  expires = DEFAULT_EXPIRES;
  constructor(props = {}) {
    props.storage && (this.storage = props.storage);
    props.pkey && (this.pkey = props.pkey);
    props.expires && (this.expires = props.expires);
    const validResult = this.__tryGetNamespaceData();
    if (!validResult) this.__createNamespace();
    routerReady.ready(router => router.addInterceptor(location => ({
      ...location, query: { ...location.query, _: this.namespace }
    })));
  }
  get key() {
    return this.pkey + this.namespace;
  }
  __tryGetNamespaceData() {
    if(this.__isExpires()) {
      return false;
    }
    if(!this.storage.getItem(this.pkey + this.namespace)) {
      return false;
    }
    return true;
  }
  __isExpires() {
    if(this.expires === -1) {
      return false;
    }
    const dNow = Date.now();
    return dNow - this.namespace > this.expires;
  }
  __createNamespace() {
    this.namespace = defaultNameSpace;
    this.storage.setItem(this.pkey + this.namespace, '{}');
    setNamespace(this.namespace);
  }
  setItem(key, value) {
    return this.storage.setItem(key, value);
  }
  getItem(key) {
    return this.storage.getItem(key);
  }
  removeItem(key) {
    return this.storage.removeItem(key);
  }
}

export default NStorage;
export const nStorage = new NStorage();

/**
 * // Currency switching removes coupon information in php price increase.
 * @param storage
 * @param storageKey
 */
export function removeCouponIfConditionMet(storage, storageKey) {
  if (isIncreasePriceForPH() && storage.getItem(storageKey)) {
    try {
      const storeJson = JSON.parse(storage.getItem(storageKey));
      if (storeJson) {
        delete storeJson.Coupon;
        storage.setItem(storageKey, JSON.stringify(storeJson));
      }
    } catch (e) {
      console.error('Error parsing or updating storage item:', e);
    }
  }
}
